'use strict';

(function () {
  angular.module('zp').controller('MixItemController', mixItemController);

  /**@ngInject */
  function mixItemController($window, $timeout, $q, $state, mixesService, vendorsService, LoaderService, mixesGridStyle) {

    var vm = this;
    var mixComposer = ['prostori', 'dekoracija-cvece', 'zlatare', 'vencanice'];

    vm.mix = null;
    vm.mixes = [];
    vm.mixItemsGridStyle = $window.innerWidth > 1200 ? mixesGridStyle.xl : mixesGridStyle.l;

    vm.openMix = openMix;
    vm.openItem = openItem;

    /**Activate */
    (function () {
      LoaderService.start();
      loadMix().then(composeMix).then(loadAllMixes).then(function () {
        $timeout(LoaderService.stop, 1000);
      });
    })();

    function loadMix() {
      return mixesService.findOne($state.params.alias).then(function (response) {
        vm.mix = response;
      });
    }

    function composeMix() {
      if (vm.mix.items && vm.mix.items.length) {
        return $q.when(function () {
          for (var i = 0; i < vm.mix.items.length; i++) {
            var item = vm.mix.items[i];
            if (i < vm.mixItemsGridStyle.length) {
              item.style = angular.copy(vm.mixItemsGridStyle[i]);
            } else {
              var gridIndex = i % vm.mixItemsGridStyle.length;
              item.style = angular.copy(vm.mixItemsGridStyle[gridIndex]);
            }
            item.style.background = item.style.background.replace('{{backgroundUrl}}', item.image.replace('https://www.dropbox.com/', 'https://dl.dropboxusercontent.com/').replace('?dl=1', ''));
          }
          return true;
        }());
      }
      var promises = [];
      for (var i = 0; i < mixComposer.length; i++) {
        promises.push(vendorsService.getRandom(mixComposer[i]));
      }
      return $q.all(promises).then(function (responses) {
        vm.mix.items = [];
        for (var i = 0; i < responses.length; i++) {
          var item = responses[i][0];
          item.style = angular.copy(vm.mixItemsGridStyle[i]);
          item.style.background = item.style.background.replace('{{backgroundUrl}}', item.images[0].url.replace('https://www.dropbox.com/', 'https://dl.dropboxusercontent.com/').replace('?dl=1', ''));
          vm.mix.items.push(item);
        }
      });
    }

    function openMix(mix) {
      $state.go('nav.mix-item', { alias: mix.alias });
    }

    function loadAllMixes() {
      vm.mixes.length = 0;
      return mixesService.getAll().then(function (response) {
        for (var i = 0; i < response.length; i++) {
          if (vm.mix.alias !== response[i].alias) {
            vm.mixes.push(response[i]);
          }
        }
      });
    }

    function openItem(mix) {
      $window.open(mix.id, '_blank');
    }
  }
})(window.angular);